import { BatteryClockIcon } from './BatteryClockIcon';

/**
 * author: Colton Wiscombe
 * id 11C7A5CA-DA77-453A-BAA8-6345949394C7
 * name battery-clock
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-clock.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Date / Time 
 */
export const BatteryFullClockIcon = BatteryClockIcon;
export default BatteryFullClockIcon